import React from 'react';
import InputRender from './InputRender';
import {InputProps} from '../../../interfaces';

export const Input = ({...props}:InputProps):JSX.Element=>{
	return <InputRender {...props}/>;
};